import { useLocalStorage } from '@mantine/hooks';
import { unique } from 'radash';

enum SearchHistoryScope {
    GLOBAL = 'searchHistory',
    DIAGRAM = 'diagramSearchHistory',
}

const useSearchHistory = (scope: SearchHistoryScope = SearchHistoryScope.GLOBAL) => {
    const [searchHistory, setSearchHistory] = useLocalStorage<string[]>({
        key: scope,
        defaultValue: [],
    });

    const addSearchHistory = (query: string) => {
        setSearchHistory((prev) => {
            return unique([query, ...prev]).slice(0, 10);
        });
    };

    return {
        searchHistory,
        addSearchHistory,
    };
};

export { SearchHistoryScope, useSearchHistory };
